import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getStatuses } from 'HELPERS/resources';
import { DataGridFiltersWrap } from 'COMPONENTS/DataGrid';
import { debounce } from 'HELPERS/utils';
import { Form, Radio } from 'antd';
import AccountSearch from './AccountSearch';

const FormItem = Form.Item;

class DataGridFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStatus: Object.prototype.hasOwnProperty.call(props.searchParams, 'status_id')
        ? parseInt(props.searchParams.status_id, 0)
        : '',
      currentSearchValue: null,
    };
    this.updateData = debounce(this.updateData, 300);
  }

  getDefaultSearchValue = () => {
    if (Object.prototype.hasOwnProperty.call(this.props.searchParams, 'account_id')) {
      return {
        type: 'account_id',
        value: parseInt(this.props.searchParams.account_id, 0),
      };
    }
    if (Object.prototype.hasOwnProperty.call(this.props.searchParams, 'client_id')) {
      return {
        type: 'client_id',
        value: parseInt(this.props.searchParams.client_id, 0),
      };
    }

    return null;
  }

  handleSelectStatus = (e) => {
    const { value } = e.target;
    if (value === '') {
      const { resource } = this.props;
      return this.setState({ selectedStatus: null }, () => {
        this.props.clearFilters(resource, ['status_id']);
      });
    }
    this.setState({ selectedStatus: value }, () => {
      this.updateResults();
    });
  }

  handleSearch = (value) => {
    if (value === null) {
      const { resource } = this.props;
      this.props.clearFilters(resource, ['client_id', 'account_id']);
    }
    this.setState({ currentSearchValue: value }, () => this.updateResults());
  }

  updateResults = () => {
    const { resource, searchParams, resourceTypeId } = this.props;
    const query = {
      status_id: this.state.selectedStatus,
      type_id: resourceTypeId,
      page: 1,
    };

    if (this.state.currentSearchValue) {
      // Avoid duplicate URL filters
      if ((this.state.currentSearchValue.type === 'client' && Object.prototype.hasOwnProperty.call(searchParams, 'account_id'))
      || (this.state.currentSearchValue.type === 'account' && Object.prototype.hasOwnProperty.call(searchParams, 'client_id'))) {
        this.props.clearFilters(resource, ['client_id', 'account_id']);
      }

      const searchKey = `${this.state.currentSearchValue.type}_id`;
      query[searchKey] = this.state.currentSearchValue.id;
    }

    this.props.updateData(this.props.resource, query);
  }

  render() {
    const statusList = [
      {
        name: 'all',
        id: '',
        label: 'All',
        color: 'default',
      },
      ...getStatuses(),
    ];

    return (
      <div className="filters-content">
        <div className="filter-item">
          <Form layout="inline">
            <FormItem>
              <Radio.Group value={this.state.selectedStatus} onChange={this.handleSelectStatus}>
                {statusList.map(status => (
                  <Radio.Button key={`filter_button_${status.name}`} value={status.id}>
                    {status.label}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </FormItem>
          </Form>
        </div>
        <div className="filter-item search">
          <AccountSearch
            onSelectValue={this.handleSearch}
            defaultValue={this.getDefaultSearchValue()}
          />
        </div>
      </div>
    );
  }
}

DataGridFilters.defaultProps = {};
DataGridFilters.propTypes = {
  resource: PropTypes.string.isRequired,
  resourceTypeId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  updateData: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};
export default DataGridFiltersWrap(DataGridFilters);



// WEBPACK FOOTER //
// ./src/components/DataGrid/DataGridFilters.js